{
  "sections": [
    {
      "section_id": "question",
      "section_type": "question",
      "section_display_name": "Question",
      "checklist": [
        {
          "id": "question_correct_structure",
          "display_name": "Has the structure of the question been parsed correctly?",
          "explanation": "https://www.notion.so/dojostack/Has-the-structure-of-the-question-been-parsed-correctly-27fb7b3bb466808490b1f08eb4c7f476",
          "type": "yes/no",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_QUESTION_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_QUESTION_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "question_format_formula",
          "display_name": "Are the formulas formatted correctly?",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Are-the-formulas-formatted-correctly-27fb7b3bb46680f1a9d1cec38f31847c",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_QUESTION_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_QUESTION_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "question_format_other",
          "display_name": "Is everything else formatted correctly?",
          "explanation": "https://www.notion.so/dojostack/Is-everything-else-formatted-correctly-27fb7b3bb4668028a318f0c70489fffa",
          "type": "yes/no",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_QUESTION_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_QUESTION_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "mcq",
      "section_display_name": "Multiple Choice Options",
      "checklist": [
        {
          "id": "mcq_correct_option",
          "display_name": "Are all the multiple-choice options correctly marked according to the original markscheme?",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Are-all-the-multiple-choice-options-correctly-marked-according-to-the-original-markscheme-27eb7b3bb46680698a60efff15e05089",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_QUESTION_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_QUESTION_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "markscheme",
      "checklist": [
        {
          "id": "markscheme_correct_mark_groups",
          "display_name": "Have all mark groups been parsed correctly?",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Have-all-mark-groups-been-parsed-correctly-27fb7b3bb46680dea537e5295728febf",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": [
            "NEEDS_MARKSCHEME_REVIEW",
            "NEEDS_EXPERT_MARKSCHEME_REVIEW"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_MARKSCHEME_REVIEW"],
              "to": "NEEDS_EXPERT_MARKSCHEME_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_MARKSCHEME_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "markscheme_correct_solution_paths",
          "display_name": "Have all the solution paths been parsed correctly?",
          "explanation": "https://www.notion.so/dojostack/Have-all-the-solution-paths-been-parsed-correctly-27fb7b3bb46680deb7bfe1fe032ccd4a",
          "type": "yes/no",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": [
            "NEEDS_MARKSCHEME_REVIEW",
            "NEEDS_EXPERT_MARKSCHEME_REVIEW"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_MARKSCHEME_REVIEW"],
              "to": "NEEDS_EXPERT_MARKSCHEME_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_MARKSCHEME_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "markscheme_correct_marks",
          "display_name": "Does the markscheme account for all marks correctly?",
          "explanation": "https://www.notion.so/dojostack/Does-the-markscheme-account-for-all-marks-correctly-27fb7b3bb466801d95e7e52a505e78f0",
          "type": "yes/no",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": [
            "NEEDS_MARKSCHEME_REVIEW",
            "NEEDS_EXPERT_MARKSCHEME_REVIEW"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_MARKSCHEME_REVIEW"],
              "to": "NEEDS_EXPERT_MARKSCHEME_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_MARKSCHEME_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "markscheme_format_formula",
          "display_name": "Are the formulas formatted correctly?",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Are-the-formulas-formatted-correctly-27fb7b3bb46680f1a9d1cec38f31847c",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": [
            "NEEDS_MARKSCHEME_REVIEW",
            "NEEDS_EXPERT_MARKSCHEME_REVIEW"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_MARKSCHEME_REVIEW"],
              "to": "NEEDS_EXPERT_MARKSCHEME_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_MARKSCHEME_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "markscheme_format_other",
          "display_name": "Is everything else formatted correctly?",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Is-everything-else-formatted-correctly-27fb7b3bb4668028a318f0c70489fffa",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": [
            "NEEDS_MARKSCHEME_REVIEW",
            "NEEDS_EXPERT_MARKSCHEME_REVIEW"
          ],
          "rejection_statuses": [
            {
              "from": ["NEEDS_MARKSCHEME_REVIEW"],
              "to": "NEEDS_EXPERT_MARKSCHEME_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_MARKSCHEME_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "image",
      "checklist": [
        {
          "id": "image_original_correct",
          "display_name": "Is the snapshot of the original image identical to the one in the source?",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Is-the-snapshot-of-the-original-image-identical-to-the-one-in-the-source-27fb7b3bb46680aaabedfddbc385bc54",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_QUESTION_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_QUESTION_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "image_generated_correct",
          "display_name": "Is the generated image sufficiently close to the original image? (content, title, not-to-scale, etc.)",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Is-the-generated-image-sufficiently-close-to-the-original-image-content-title-not-to-scale-etc-27fb7b3bb4668093a5e6d218cac50436",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_IMAGE_REVIEW", "NEEDS_EXPERT_IMAGE_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_IMAGE_REVIEW"],
              "to": "NEEDS_EXPERT_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_IMAGE_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "image_correct_layout",
          "display_name": "Is the layout of the image identical to the original? (alignment, height, width, etc.)",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Is-the-layout-of-the-image-identical-to-the-original-alignment-height-width-etc-27fb7b3bb466802c9d59e134f00b23bc",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_IMAGE_REVIEW", "NEEDS_EXPERT_IMAGE_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_IMAGE_REVIEW"],
              "to": "NEEDS_EXPERT_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_IMAGE_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "image_correct_fill_in_the_blanks",
          "display_name": "Are the fill-in-the-blanks correctly marked?",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Are-the-fill-in-the-blanks-correctly-marked-2b0b7b3bb46680dfb858d4280b1ed60f",
          "display": "in_stem",
          "pass_condition": "yes_response",
          "show_extra_text_field": "no_response",
          "in_statuses": ["NEEDS_IMAGE_REVIEW", "NEEDS_EXPERT_IMAGE_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_IMAGE_REVIEW"],
              "to": "NEEDS_EXPERT_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_IMAGE_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        }
      ]
    },
    {
      "section_id": null,
      "section_type": "table",
      "checklist": [
        {
          "id": "table_generated_correct",
          "display_name": "Is the generated table sufficiently close to the original table? (content, title, etc.)",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Is-the-generated-table-sufficiently-close-to-the-original-table-content-title-etc-27fb7b3bb46680e0b311f74bb651cfc8",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_IMAGE_REVIEW", "NEEDS_EXPERT_IMAGE_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_IMAGE_REVIEW"],
              "to": "NEEDS_EXPERT_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_IMAGE_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "table_correct_layout",
          "display_name": "Is the layout of the table identical to the original? (width, padding, etc.)",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Is-the-layout-of-the-table-identical-to-the-original-width-padding-etc-27fb7b3bb46680c6853cfbf85d753813",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_IMAGE_REVIEW", "NEEDS_EXPERT_IMAGE_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_IMAGE_REVIEW"],
              "to": "NEEDS_EXPERT_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_IMAGE_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        },
        {
          "id": "table_correct_fill_in_the_blanks",
          "display_name": "Are the fill-in-the-blanks correctly marked?",
          "type": "yes/no",
          "explanation": "https://www.notion.so/dojostack/Are-the-fill-in-the-blanks-correctly-marked-2b0b7b3bb46680dfb858d4280b1ed60f",
          "display": "in_stem",
          "show_extra_text_field": "no_response",
          "pass_condition": "yes_response",
          "in_statuses": ["NEEDS_IMAGE_REVIEW", "NEEDS_EXPERT_IMAGE_REVIEW"],
          "rejection_statuses": [
            {
              "from": ["NEEDS_IMAGE_REVIEW"],
              "to": "NEEDS_EXPERT_IMAGE_REVIEW"
            },
            {
              "from": ["NEEDS_EXPERT_IMAGE_REVIEW"],
              "to": "UNFIXABLE"
            }
          ]
        }
      ]
    }
  ]
}
